<template lang="pug">
section#cadastro-lote.upload-lote
    h3.upload-lote__title Ingresar territorio por lote

    .upload-lote__card
        .upload-lote__info
            span.upload-lote__description
                | Para agilizar el proceso, puedes añadir más de un territorio a la vez utilizando un archivo&nbsp;
                strong .zip
                | .
            span.upload-lote__subtitle El paquete debe contener los siguientes archivos:

        .dropzone
            .upload-lote__fields-container
                ul.upload-lote__fields-list
                    li.upload-lote__fields-item-obg Planilla #[code .xlsx] en la raíz
                    li.upload-lote__fields-item-obg Archivos #[code .kml] referenciados

                span.upload-lote__hint
                    i.mdi.mdi-information-outline
                    | La planilla debe contener la columna #[strong NOMBRE_FILE] con el nombre exacto de cada archivo .kml incluido en el .zip.

                span.upload-lote__fields-subtitle Columnas de la planilla:
                .upload-lote__fields-list.upload-lote__fields-list--planilha
                    ul.upload-lote__fields-list-inner
                        li.upload-lote__fields-item-obg Nombre territorio
                        li.upload-lote__fields-item-obg Nombre file
                        li.upload-lote__fields-item Codigo unico empresa
                        li.upload-lote__fields-item-obg Cultivo
                        li.upload-lote__fields-item-obg Produtor
                        li.upload-lote__fields-item-obg Cuit
                        li.upload-lote__fields-item-obg Departamento
                        li.upload-lote__fields-item-obg Distrito
                        li.upload-lote__fields-item RENSPA
                        li.upload-lote__fields-item-obg ONCCA

            .dropzone__box
                el-upload(
                    action='#'
                    :auto-upload='false'
                    :on-change='validarEEnviarZip'
                    :on-exceed='onExceed'
                    :file-list='fileList'
                    :limit='1'
                    drag
                    ref='uploadZipTerritorio'
                    accept='.zip'
                )
                    i.el-icon-upload
                    .el-upload__text
                        | Arrastre el archivo #[em .zip] aquí o&nbsp;
                        em haga clic para subir
                    .el-upload__tip(slot='tip')
                        | Solo archivos #[strong .zip] · Máximo 50 MB

                .dropzone__download-link
                    span.btn-download(@click='downloadPlanilhaExemplo()')
                        i.mdi.mdi-download
                        span Descargar modelo de planilla

        template(v-if='dadosLote.status')
            DadosLote(:dadosLote='dadosLote')
</template>

<script>
import DadosLote from './dados-lote/index.vue';
import JSZip from 'jszip';
import TerritorioServiceArgentina from '@/services/TerritorioServiceArgentina.js';

export default {
    name: 'UploadLoteTerritorio',
    components: {
        DadosLote
    },

    data() {
        return {
            fileList: [],
            carregando: false,
            dadosLote: {
                id: null,
                planilha: '',
                planilhaErro: false,
                dataCadastro: '',
                dataAtualizacao: '',
                status: ''
            }
        };
    },

    mounted() {
        this.buscarDadosLote();
    },

    methods: {
        async validarEEnviarZip(arquivo) {
            if (!this.validarExtensaoZip(arquivo)) return;
            if (!this.validarTamanho(arquivo)) return;

            const conteudoZip = await this.abrirZip(arquivo);
            if (!conteudoZip) return;

            if (!this.validarPlanilhaNoZip(conteudoZip)) return;

            await this.enviarZip(arquivo);
        },

        validarExtensaoZip(arquivo) {
            const extensao = arquivo.name.split('.').pop().toLowerCase();
            if (extensao !== 'zip') {
                this.$notify.error({
                    title: 'Formato inválido',
                    message: 'Solo se admiten archivos con la extensión .zip.'
                });
                this.$refs.uploadZipTerritorio.clearFiles();
                return false;
            }
            return true;
        },

        validarTamanho(arquivo) {
            const LIMITE_BYTES = 50 * 1024 * 1024;
            if (arquivo.size > LIMITE_BYTES) {
                this.$notify.warning({
                    message: 'Este archivo supera el límite de 50 MB.'
                });
                this.$refs.uploadZipTerritorio.clearFiles();
                return false;
            }
            return true;
        },

        async abrirZip(arquivo) {
            try {
                return await JSZip.loadAsync(arquivo.raw);
            } catch {
                this.$notify.error({
                    title: 'Archivo inválido',
                    message: 'No fue posible leer el archivo .zip. Verifique si el archivo no está corrompido.'
                });
                this.$refs.uploadZipTerritorio.clearFiles();
                return null;
            }
        },

        validarPlanilhaNoZip(zip) {
            const planilhasNaRaiz = Object.values(zip.files).filter(f => {
                if (f.dir) return false;
                const nomeSimples = f.name.replace(/^\//, '');
                return !nomeSimples.includes('/') && nomeSimples.toLowerCase().endsWith('.xlsx');
            });

            if (planilhasNaRaiz.length === 0) {
                this.$notify.error({
                    title: 'Planilla no encontrada',
                    message: 'Planilla de datos no encontrada en la raíz del archivo. Incluya un archivo .xlsx directamente en el .zip, sin subcarpetas.'
                });
                this.$refs.uploadZipTerritorio.clearFiles();
                return false;
            }

            return true;
        },

        async enviarZip(arquivo) {
            this.carregando = true;
            try {
                const { data } = await TerritorioServiceArgentina.previewViaZip(arquivo);

                if (data.itensSobrepostos > 0) {
                    this.$notify.warning({
                        message: this.$t(
                            'mensagens.territorio.territorioAr.uploadLote.sobrepostosNaoImportados',
                            { n: data.itensSobrepostos }
                        )
                    });
                }

                this.$emit('territoriosCarregados', data);
                this.$store.dispatch('setNomeArquivoLotePreviewAR', arquivo.name);
                await this.buscarDadosLote();
            } catch {
                this.$notify.error({ message: 'Error al procesar el archivo.' });
            } finally {
                this.carregando = false;
                this.$refs.uploadZipTerritorio.clearFiles();
            }
        },

        onExceed() {
            this.$notify.warning({
                message: 'Solo se permite la carga de un archivo a la vez.',
                position: 'top-left'
            });
        },

        downloadPlanilhaExemplo() {
            const link = document.createElement('a');
            link.href = 'https://lyra-bunge-publico.s3.us-east-1.amazonaws.com/planilla_ejemplo_territorios_en_lote_AR.xlsx';
            link.setAttribute('download', 'planilla-ejemplo-territorio.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        factoryDadosLote(lote) {
            const { id, planilha, planilhaErro, dataCadastro, dataAtualizacao, status } = lote;
            return { id, planilha, planilhaErro, dataCadastro, dataAtualizacao, status };
        },

        async buscarDadosLote() {
            try {
                const { data } = await TerritorioServiceArgentina.buscarDadosLoteCadastroViaPlanilha();
                if (data) {
                    this.dadosLote = this.factoryDadosLote(data);
                }
            } catch {
                // histórico de lote pode não existir ainda
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.upload-lote {
    span, p, li {
        color: #303133;
    }

    &__title {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
    }

    &__info {
        .upload-lote__subtitle,
        .upload-lote__description {
            display: block;
        }
    }

    &__hint {
        align-items: flex-start;
        font-size: 12px;
        color: #606266;
        margin-top: 10px;

        i {
            font-size: 14px;
            color: #909399;
            flex-shrink: 0;
            margin-top: 1px;
        }
    }

    &__card {
        background-color: #ffffff;
        border: 1px solid #ebeef5;
        padding: 20px;
        border-radius: 10px;

        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    &__fields-subtitle {
        display: block;
        font-size: 12px;
        font-weight: 600;
        color: #606266;
        margin-bottom: 6px;
        margin-top: 14px;
    }

    &__fields-list--planilha {
        margin-top: 12px;
    }

    &__fields-list-inner {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        width: 500px;

        li.upload-lote__fields-item-obg::after {
            content: ' *';
            color: #f56c6c;
        }
    }

    .dropzone {
        display: flex;
        gap: 24px;

        .upload-lote__fields-container {
            .upload-lote__fields-list {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                width: 500px;

                li.upload-lote__fields-item-obg::after {
                    content: ' *';
                    color: #f56c6c;
                }
            }
        }

        .dropzone__box {
            width: 100%;

            i {
                color: var(--primary);
                font-size: 30px;
            }

            .dropzone__download-link {
                display: flex;
                justify-content: flex-end;
                gap: 15px;
                align-items: center;
                width: 100%;

                .btn-download {
                    cursor: pointer;
                    display: flex;
                    gap: 5px;
                    font-weight: 600;

                    i {
                        font-size: 15px;
                    }

                    span {
                        text-decoration: underline;
                        color: var(--primary);
                    }
                }
            }
        }
    }
}

::v-deep .el-upload-dragger {
    background-color: #f2f2f2 !important;

    &:hover {
        border-color: var(--primary);
    }
}

.dropzone__box {
    ::v-deep .el-upload-dragger:hover {
        border-color: var(--primary);
    }
}
</style>
